import { Button, Text, Card } from "../../../components";
import Localization from "../../../localization";
import React, { useCallback } from "react";
import styled from "styled-components";
import { Flex } from "antd";

const OrderAlarm = ({ packages = [] }) => {
  const renderListItem = useCallback(
    ({ title, subTitle, desc, image, orderLink }) => (
      <Card className="item">
        <Flex
          gap={"2.5rem"}
          align="flex-start"
          justify="space-between"
          className="flex-column-reverse-mobile"
        >
          <div>
            <Text level={5} children={title} />
            <Text
              weight={"600"}
              className="m-5-t"
              color="secondary"
              children={subTitle}
            />
          </div>
          <img style={{ height: "5.5rem" }} src={image} />
        </Flex>
        <Text color="secondary" children={desc} className="description" />
        <Flex className="m-20-t" gap={"1rem"}>
          <Button
            type="primary"
            onClick={() => window.open(orderLink)}
            title={Localization.api.services.devicePackages.premiumlarmet_btn_0}
          />
        </Flex>
      </Card>
    ),
    []
  );

  return (
    <Styled>
      <Text
        level={4}
        weight={"700"}
        color="secondary"
        className="m-25-b"
        lineHeight="normal"
        children={Localization.purchase.alarm_pkg_subtitle}
      />
      <Flex
        vertical
        children={React.Children.toArray(packages.map(renderListItem))}
      />
    </Styled>
  );
};

const Styled = styled.div`
  .item {
    .ant-card-body {
      padding: 2rem;
      background: ${(_) => _.theme.token.surface.primary};
      .description {
        margin-top: 3.2rem !important;
        ${(_) => _.theme.mobile(`margin-top: 2rem !important;`)}
      }
    }
  }
`;

export default OrderAlarm;
